import {Trans, useTranslation} from '@/translations/i18n.tsx'
import {FC} from 'react'
import {ButtonLink} from '@components/commons/button-link'
import {LinkExternal02Icon} from '@components/ui/icon'
import {ASSIGNMENT_CARD_WRAPPER_CLASSNAME, ASSIGNMENT_CARD_TITLE_CLASSNAME} from '@features/assignment/constants'
import {UPWORK_URL} from '@features/payments/constants'

export const AssignmentUpworkCompensationCard: FC = () => {
    const {t} = useTranslation()

    return (
        <div className={ASSIGNMENT_CARD_WRAPPER_CLASSNAME}>
            <h3 className={ASSIGNMENT_CARD_TITLE_CLASSNAME}>{t('assignment:upwork_compensation_card:title')}</h3>

            <p className="text-xs text-neutral-600">
                <Trans
                    i18nKey="assignment:upwork_compensation_card:description"
                    components={{
                        a: (
                            <a
                                href={UPWORK_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="cursor-pointer underline"
                            />
                        )
                    }}
                />
            </p>

            <ButtonLink
                className="md:self-end w-full md:w-auto"
                size="md"
                target="_blank"
                to={UPWORK_URL}
                variant="brand"
            >
                {t('assignment:upwork_cta')}
                <LinkExternal02Icon size={16} />
            </ButtonLink>
        </div>
    )
}

AssignmentUpworkCompensationCard.displayName = 'AssignmentUpworkCompensationCard'
